import { projects, skills } from '../../data'
import './Navbar.css'

const Navbar = () => (
  <nav className='center nav'>
    <ul className='nav__list'>
      {projects.length ? (
        <li className='nav__list-item'>
          <a href='#projects' className='link link--nav'>
            Projects
          </a>
        </li>
      ) : null}

      {skills.length ? (
        <li className='nav__list-item'>
          <a href='#skills' className='link link--nav'>
            Skills
          </a>
        </li>
      ) : null}

      <li className='nav__list-item'>
        <a href='#contact' className='link link--nav'>
          Contact
        </a>
      </li>
    </ul>
  </nav>
)

export default Navbar
